import React, { useEffect, useState } from 'react';
import Modal from "components/Modal";
import PubSub from 'services/PubSub/';
import AddressSelect from './AddressSelect';
import { LoadScript } from '@react-google-maps/api';
import { googleMaps } from 'config/index';
import { actionsType } from 'config/constants';
import NewRelicService from 'services/NewRelic'
import style from './style.scss';//NOSONAR

let actions = [];

const ModalAddress = () => {
    const [address, setAddress] = useState(null);
    const [headerCheckout, setHeaderCheckout] = useState(false);
    const [changeTitle, setChangeTitle] = useState(false);

    useEffect(()=> {
        actions.push(PubSub.register(actionsType.MODAL.ADDRESS_OPEN, _setAddress));
        actions.push(PubSub.register('change_title_modal', titleChange));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
        }
    }, []);

    const close = () => {
        NewRelicService.sendPageAction({
            action: 'modalAddress',
            payload: {
                status: 'close'
            }
        })
    }

    const _setAddress = (payload) => {
        NewRelicService.sendPageAction({
            action: 'modalAddress',
            payload: {
                status: 'open'
            }
        })
        setAddress(payload.value.address);
        setHeaderCheckout(payload.value.headerCheckout)
    };

    const titleChange = (payload) => {
        if(payload.value){
            setChangeTitle(payload.value.changeTitle);
        }
    }

    const titleModal = address ? 'Cambiar dirección' : 'Agrega tu dirección';

    return <Modal customClass={'modal-address' + (headerCheckout ? ' header-checkout' : '')} actionOpen={actionsType.MODAL.ADDRESS_OPEN} actionClose={actionsType.MODAL.ADDRESS_CLOSE} callback={close}>
        <div className='new-modal-title-wrap'><h2 className='new-modal-title'>{!changeTitle ? titleModal : 'Confirma tu dirección'}</h2></div>
        <section className='modal-address-content'>
            <LoadScript googleMapsApiKey={googleMaps.api} version="quarterly" libraries={["geometry","drawing","places"]} language="es" >
                <AddressSelect editAddress={address || {}} />
            </LoadScript>
        </section>
    </Modal>
};

export default ModalAddress;
